var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 100,
    viewBox: "0 0 106 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2066_7610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.9995,
    cy: 50,
    r: 49.4139,
    transform: "rotate(0.100934 52.9995 50)",
    fill: "#F1F3F9",
    stroke: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2066_7610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3161 45.5066C83.4699 23.909 66.9761 20.7285 59.5794 20.7285C36.2809 20.7285 30.5711 30.9209 28.3606 42.1782C25.4533 38.8498 10.393 39.5895 5.95531 56.971C1.60018 74.0292 11.8725 79.9 22.9671 79.9H90.6445C109.875 72.8734 99.5202 42.1782 87.3161 45.5066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7748 52.1633C27.5345 49.3098 27.6484 45.8049 28.3606 42.1782M28.3606 42.1782C30.5711 30.9209 36.2809 20.7285 59.5794 20.7285C66.9761 20.7285 83.4699 23.909 87.3161 45.5066C99.5202 42.1782 109.875 72.8734 90.6445 79.9H22.9671C11.8725 79.9 1.60018 74.0292 5.95531 56.971C10.393 39.5894 25.4533 38.8498 28.3606 42.1782Z",
    stroke: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4012 45.5059C84.1961 47.2317 78.0817 51.2011 79.2651 53.2721",
    stroke: "#D6DCE8"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 54.2515,
    cy: 66.2534,
    r: 19.728,
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3107 55.3296C54.7249 54.7438 53.7751 54.7438 53.1893 55.3296L43.6434 64.8755C43.0576 65.4613 43.0576 66.4111 43.6434 66.9968C44.2292 67.5826 45.1789 67.5826 45.7647 66.9968L54.25 58.5116L62.7353 66.9968C63.3211 67.5826 64.2708 67.5826 64.8566 66.9968C65.4424 66.4111 65.4424 65.4613 64.8566 64.8755L55.3107 55.3296ZM55.75 79.9121L55.75 56.3902L52.75 56.3902L52.75 79.9121L55.75 79.9121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2066_7610",
    x: 3.08594,
    y: 0.0859375,
    width: 101.828,
    height: 103.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2066_7610"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2066_7610",
    x: 0.431641,
    y: 20.2285,
    width: 105.363,
    height: 68.1719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2066_7610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2066_7610",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSvg);
export default __webpack_public_path__ + "static/media/UploadSVG.a080712d6804d3d4d971316f09ccc208.svg";
export { ForwardRef as ReactComponent };